import {all} from 'redux-saga/effects'

import locationHref from './locationHref.js'
import ui from './ui/index.js'

export default function* rootSaga() {
  yield all([locationHref(), ui()])
}
